(function (angular, app) {
   "use strict";

   angular.module(app.modules.common.name)
      .factory(app.modules.common.services.functions, FunctionFactory);
   
   FunctionFactory.$inject = ["$q", "$timeout", "$window", "smoothScroll"
   , app.modules.common.constants.themelist
   , app.modules.common.services.eventbus
   ];
   
   function FunctionFactory($q, $timeout, $window, ngSmoothScroll
      , ggThemes
      , ggEvents
      ) {
      
      //##//--------------------------------------- 
      

      var goToPage = function (path) {
          /*
          if (path == '' || path == app.modules.view.routes.intro.path) {
            if (app.Member.Auth.isAuthenticated) {
               path = app.modules.member.routes.home.path;
            } else {
               path = app.modules.view.routes.intro.path;
            }
         }
         */

         top.location.href= "#" + path; 
      }
      var cacheBuster = function(url){
          url = url;// + "?" + Math.random();
         return url;
      }
      var fetchWindowSize = function (headHeight) {

         // Default Margin Height
         var marginHeight = 40;
         // Default Head Height
         headHeight = headHeight || 61;
         

         // Max height is the scrollable content height of the modal

         var windowSize = {
            width: $window.innerWidth
           , height: $window.innerHeight
            , modal: {
               width : "600px"
               , height: "auto"
               , maxHeight: "none"
               , wide: 600
               , high: $window.innerHeight - marginHeight - headHeight
            }
         }

         if (windowSize.width > 600) {
             windowSize.modal.width = "600px";
             windowSize.modal.wide = 600;
            windowSize.modal.height = "auto";
            windowSize.modal.maxHeight = (windowSize.height - headHeight - marginHeight) + "px";
         } else {
             windowSize.modal.height = windowSize.height - headHeight + "px";
             windowSize.modal.high = windowSize.height - headHeight - marginHeight;
             windowSize.modal.maxHeight = "none";
             windowSize.modal.wide = $window.innerWidth;
         }

         return windowSize;
      }
      var fetchThemeById = function (id) {
         var r = ggThemes[0];
         if (id) {
            for (var x = 0; x < ggThemes.length; x++) {
               if (id == ggThemes[x].themeId) {
                  r = ggThemes[x];
               }
            }
         }
         return r;
      }

      var isEmailValid = function (email) {
            var re = /\S+@\S+\.\S+/;
            return re.test(email);
      }


      var formatDateString = function (d, format, isTime) {
         if (!d) {
            d = new Date();
         } 

         var nd = "";
         // When formatting, don't start in ISO.  change to mm/dd/yyyy
         if (Object.prototype.toString.call(d) === '[object Date]') {
            nd = dateFormat(d, "mm/dd/yyyy").toString();
         } else {
            nd = d.toString();
         }

         if (nd.indexOf("-") > 0) {
            // If it's already ISO, change it to 01/23/1978
            nd = d.substr(5, 2) + "/" + d.substr(8, 2) + "/" + d.substr(0, 4);
         }
         
         var rd = new Date(nd);
         nd = dateFormat(rd, format).toString();

         if (format == "yyyy-mm-dd" && isTime) {
            nd = nd + "T00:00:00";
         }
         return nd;
      }
      var doubleDigit = function(n){
         var st = "";
         if(Number(n) < 10){
            st = "0" + n;
         }else{
            st = n;
         }
         return st;
      }

      var calcDifferential = function(score, rating, slope){
         var differential = 0.0
         differential = (score - rating) * (113/slope);
         differential = Math.round(differential*10);
         differential = (differential/10.0).toFixed(1);
         return differential;
      }
      var scrollToTop = function(scrollDuration, callback) {
           
          if (!scrollDuration) {
              scrollDuration = 10;
          }
          if (scrollDuration < 100 && scrollDuration != 0) {
              scrollDuration = 10
          }
          if (scrollDuration > 300) {
              scrollDuration = 300;
          }

          if (scrollDuration == 0) {
              window.scrollTop();
              if (callback) {
                  callback();
              }
          } else {
              var element = document.getElementsByTagName("body");
              ngSmoothScroll(element, { duration: scrollDuration, callbackAfter: callback });
          }
          

      }

      // hack to create a unique id
      var uuid = {
         new: function () {
            function _p8(s) {
               var p = (Math.random().toString(16) + "000000000").substr(2, 8);
               return s ? "-" + p.substr(0, 4) + "-" + p.substr(4, 4) : p;
            }
            return _p8() + _p8(true) + _p8(true) + _p8();
         },
         empty: function () {
            return '00000000-0000-0000-0000-000000000000';
         }
      }
      
      // Render Player Profile Picure
      var renderProfilePicture = function(memberObj){
         var div = "";
         var player = memberObj;

         var player = {
            id: memberObj.id
            , firstName: memberObj.firstName
            , lastName: memberObj.lastName
            , profileImage: ""
            , initials: ""
         }

         if (player.firstName.length > 0) {
            player.initials = player.firstName.substring(0, 1);
         }
         if (memberObj.lastName.length > 0) {
            player.initials += player.lastName.substring(0, 1);
         }

         if (player.profileImage != "") {
            div += "<div class='profile-picture-icon' title='" + player.firstName + ' ' + player.lastName + "'><img src='image' /></div>";
         } else {
            div += "<div class='profile-picture-initial' title='" + player.firstName + ' ' + player.lastName + "'>" + player.initials + "</div>";
         }
         
         // Return HTML
         return div;
      }

      var qSequence = function (fn, data) {
         var chain = $q.when();
         data.forEach(function (form) {
            chain = chain.then(
               function () {
                  return $timeout(function () {
                     return fn(form);
                  }, 0)
               }
            );
         });
         return chain;
      }

      var formatScoreType = function (name) {
         var st = "";

         if (name == "Away") {
            st = "A"
         }
         if (name == "Combined") {
            st = "C"
         }
         if (name == "Penalty") {
            st = "P"
         }
         if (name == "Tournament") {
            st = "T"
         }
         if (name == "TournamentAway") {
            st = "TA"
         }

         return st;
      }

      var toggleProcessing = function (isProcessing) {
         ggEvents.broadcast(app.modules.common.events.toggleProcessing, { isProcessing: isProcessing });
      }

      var parseDBTime = function (time, isMilitary) {
         var hr = "12";
         var mn = "00";
         var am = "AM"
         var st = ""

         time = time.substring(2, time.length);
         if (time.indexOf("H") > 0) {
            hr = time.substring(0, time.indexOf("H"));
            if (hr > 11) {
               am = "PM";
               if (hr > 12 && !isMilitary) {
                  hr = hr - 12;
               }
            }

         }
         if (time.indexOf("M") > 0) {
            if (time.indexOf("H") > 0) {
               mn = time.substring(time.indexOf("H") + 1, time.indexOf("M"))
            } else {
               mn = time.substring(0, time.indexOf("M"))
            }
         }

         if (hr.length == 1) {
            hr = "0" + hr;
         }
         if (mn.length == 1) {
            mn = "0" + mn;
         }
         if (isMilitary) {
            st = hr + ":" + mn;
         } else {
            st = hr + ":" + mn + " " + am;
         }
         


         return st;
      }

      var formatMemberName = function (member) {
          var fn, ln, un;

          var Member = {};
          if (member) {
              Member = member;
          }

         fn = Member.firstName || "";
         ln = Member.lastName || "";
         un = Member.userName;
         if (fn == "") {
            if (ln == "") {
               fn = un;
               if (fn && fn.indexOf("@") > -1) {
                  fn = fn.substring(0, fn.indexOf("@"));
               } else {
                   if (!fn) {
                       fn = "";
                   }
               }

            } else {
               fn = ln.substring(0, 1);
            }
         }
         Member.firstName = fn;
         Member.lastName = ln;
         return Member;
      }

      //##//--------------------------------------- 

      var service = {
         goToPage: goToPage
         , fetchWindowSize : fetchWindowSize
         , cacheBuster : cacheBuster
         , formatDateString: formatDateString
         , doubleDigit : doubleDigit
         , calcDifferential : calcDifferential 
         , scrollToTop: scrollToTop
         , isEmailValid: isEmailValid
         , fetchThemeById: fetchThemeById
         , uuid: uuid
         , renderProfilePicture: renderProfilePicture
         , qSequence: qSequence
         , formatScoreType: formatScoreType
         , toggleProcessing: toggleProcessing
         , parseDBTime: parseDBTime
         , formatMemberName: formatMemberName
      };
      
      return service;
   }
   
}(angular, app));
